import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import Modal from 'react-modal';
import {injectIntl} from 'react-intl';
import {graphql} from '@apollo/client/react/hoc/graphql';
import {pick, mapValues} from 'lodash';

import {FormattedMessage} from 'components/FormattedComponents';
import CookieDialog from 'components/CookieDialog';
import Spinner from 'components/Spinner';

import messages from './messages';
import {
  getContentStyles,
  getOverlayStyles,
  StyledLink,
  ContentWrapper,
  TopSection,
  BottomSection,
  StyledButton
} from './styles';

import {PRIVACY_POLICY_URL} from '../../constants';

//mutations
import {ConsentCookies} from 'api/consent-cookies/mutations';
import {consentCookiesOptions} from 'api/consent-cookies/mutation-options';

@inject('store')
@graphql(ConsentCookies, consentCookiesOptions)
@observer
class CookieBanner extends Component {
  async componentDidMount() {
    const {
      intl: {formatMessage},
      store: {cookiePreference}
    } = this.props;

    const translations = mapValues(pick(messages, ['couldntSavePreferences']), message => formatMessage(message));
    cookiePreference.setTranslations(translations);
    await cookiePreference.updateCookiesFromCurrentPreferenceCookie();
  }

  render() {
    const {
      intl: {formatMessage},
      isMobile,
      ModalComponent = Modal,
      goToPrivacyPage,
      consentCookiesMutation,
      store: {
        cookiePreference: {
          cookiePreferenceDialogOption,
          showBanner,
          showCookiePreferenceDialog,
          savePreferenceButtonLoading,
          acceptAllCookiesButtonLoading,
          acceptAllCookies,
          setCookiePreferenceOption,
          savePreferences,
          openCookiePreferencesDialog,
          hideCookiePreferencesDialog
        }
      }
    } = this.props;

    const styles = {
      overlay: getOverlayStyles(),
      content: getContentStyles()
    };

    return (
      <div>
        {!showCookiePreferenceDialog && (
          <ModalComponent isOpen={showBanner} style={styles} ariaHideApp={false}>
            <ContentWrapper>
              <TopSection isMobile={isMobile}>
                <FormattedMessage
                  {...messages.infoBanner}
                  values={{
                    cookiePolicyLink: (
                      <StyledLink href={PRIVACY_POLICY_URL} target="_blank">
                        <FormattedMessage {...messages.cookiePolicy} />
                      </StyledLink>
                    )
                  }}
                />
              </TopSection>
              <BottomSection>
                <StyledLink onClick={openCookiePreferencesDialog}>
                  {formatMessage(messages.managePreferences)}
                </StyledLink>
                <StyledButton
                  role="button"
                  disabled={acceptAllCookiesButtonLoading}
                  onClick={() => acceptAllCookies(consentCookiesMutation)}
                >
                  {acceptAllCookiesButtonLoading ? (
                    <Spinner color="white" size="20px" centerAbs centerX centerY />
                  ) : (
                    formatMessage(messages.accept).toUpperCase()
                  )}
                </StyledButton>
              </BottomSection>
            </ContentWrapper>
          </ModalComponent>
        )}
        <CookieDialog
          isMobile={isMobile}
          ModalComponent={ModalComponent}
          width={730}
          boxShadow={true}
          isOpen={showCookiePreferenceDialog}
          onClose={hideCookiePreferencesDialog}
          acceptAllCookies={acceptAllCookies}
          cookiePreference={cookiePreferenceDialogOption}
          setCookiePreferenceOption={setCookiePreferenceOption}
          savePreferences={savePreferences}
          goToPrivacyPage={goToPrivacyPage}
          consentCookiesMutation={consentCookiesMutation}
          savePreferenceButtonLoading={savePreferenceButtonLoading}
          acceptAllCookiesButtonLoading={acceptAllCookiesButtonLoading}
        />
      </div>
    );
  }
}

export default injectIntl(CookieBanner);
